const PROPERTIES = [
  { name: "Son's Blue River Camp", river: "San Marcos River", url: "https://bluerivercamp.com/", description: "Spring-fed river, cabanas, glamping, and tubing in Kingsbury, TX." },
  { name: "Son's River Ranch", river: "Guadalupe River", url: "https://sonsriverranch.com/", description: "Sister property on the Guadalupe with glamping cabins and river access." },
  { name: "Son's Rio Cibolo", river: "Cibolo Creek", url: "https://sonsriocibolo.com/", description: "Cibolo Creek getaways with shaded cabanas and event space." },
  { name: "Son's Geronimo", river: "Geronimo Creek", url: "https://sonsgeronimo.com/", description: "Quiet creekside cabins and event venue near Seguin." },
  { name: "Son's Guadalupe", river: "Guadalupe River", url: "https://sonsguadalupe.com/", description: "Guadalupe River cabanas, tubing, and family day trips." },
  { name: "Son's Island", river: "Lake Placid", url: "https://sonsisland.com/", description: "Private island cabana experience near Seguin." },
];

const SonsGetawaysCluster = ({ currentDomain = "bluerivercamp.com" }: { currentDomain?: string }) => {
  const others = PROPERTIES.filter((p) => !p.url.includes(currentDomain));
  return (
    <section className="py-14 bg-secondary/30 border-y border-border/40">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="max-w-3xl mx-auto text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-3">
            More From the Son's Getaways Family
          </h2>
          <p className="text-muted-foreground">
            Six Texas river properties, one family-run group. If our calendar is full, our sister sites have you covered.
          </p>
        </div>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {others.map((p) => (
            <a
              key={p.url}
              href={p.url}
              target="_blank"
              rel="noopener"
              className="block rounded-lg border border-border bg-card p-5 shadow-soft transition-all hover:-translate-y-0.5 hover:border-river/30 hover:shadow-elevated"
            >
              <h3 className="font-heading text-lg font-semibold text-foreground mb-1">{p.name}</h3>
              <div className="text-xs text-river uppercase font-cta tracking-wider mb-2">{p.river}</div>
              <p className="text-sm text-muted-foreground leading-relaxed">{p.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SonsGetawaysCluster;